import React from 'react'
import { useModal } from '@mprolab/uikit'
import isNil from 'lodash/isNil'
import AwaitingVerificationModal from './AwaitingVerificationModal'

export interface ReturnType {
  onPresentAwaitingVerificationModal: () => void
  onModalClose: (success?: boolean) => void
}

export interface IVerificationModalProps {
  onVerificationCallback?: (success: boolean) => void
}

const useAwaitingVerificationModal = ({ onVerificationCallback }: IVerificationModalProps): ReturnType => {
  const [onPresentAwaitingVerificationModal, onDismiss] = useModal(
    <AwaitingVerificationModal
      onVerificationDeclined={() => {
        if (onVerificationCallback) onVerificationCallback(false)
      }}
    />,
    false
  )

  const onModalClose = (success?: boolean) => {
    onDismiss()
    if (!isNil(success) && onVerificationCallback) onVerificationCallback(success)
  }

  return { onPresentAwaitingVerificationModal, onModalClose }
}

export default useAwaitingVerificationModal
